import { Card, Container } from '@mui/material';
import { Alert } from '@mui/lab';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { approveCommercialException } from 'src/actions/commercialExceptionRequests';
import Loading from '../baseComponents/Loading';
import './index.scss';

const CommercialExceptionApproval = () => {
  const [verifying, setVerifying] = useState(true);
  const [verified, setVerified] = useState(false);
  const [message, setMessage] = useState('');
  const { loanId, userEmail } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleApproval = async () => {
      const res = await approveCommercialException({ loanId, userEmail });
      setMessage(res?.message);
      setVerifying(false);
      setVerified(true);
      setTimeout(() => {
        // Replace: a push let back return to this URL, whose effect re-POSTs
        // the approval.
        navigate('/dashboard', { replace: true });
      }, 3000);
    };

    if (loanId) handleApproval();
  }, [loanId, userEmail, navigate]);

  return (
    <div className='commercial-exception-approval flex flex-container flex-center'>
      <Container maxWidth='md'>
        <Card className='flex-container container' elevation={4}>
          <div className='flex flex-container flex-center'>
            <div className='flex flex-container flex-center'>
              <h1 class='title'>Commercial Exception Approval</h1>
              {verifying && (
                <>
                  <Loading label='Approving...' />
                </>
              )}
              {verified && (
                <Alert variant='filled' severity='success'>
                  {message}
                </Alert>
              )}
              {!verified && !verifying && (
                <Alert variant='filled' severity='error'>
                  {message}
                </Alert>
              )}
            </div>
          </div>
        </Card>
      </Container>
    </div>
  );
};

export default CommercialExceptionApproval;
